import PlanDurationBanner from 'Components/dashboard/PlanDurationBanner';
import TrialPlanBanner from 'Components/dashboard/TrialPlanBanner';
import React from 'react'
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { RootState } from 'store';

const CurrentMembershipCard: React.FC<{onCancelMembership?: () => void, onProceedToCheckout?: (planId: string | number, frequency: string) => void}> = ({onCancelMembership, onProceedToCheckout}) => {
    const membershipData = useSelector((state: RootState) => state.membershipState.membership.data)
    const activePlan = membershipData?.active_plan;
    const subscriptionFeatures = membershipData?.subscription_features ?? {}

    const [processing, setProcessing] = React.useState(false);

    const handleCancelMembership = async () => {
        setProcessing(true);
        try {
            if(onCancelMembership) {
                await onCancelMembership();
            }
        } catch (error) {
            console.log(error);
        } finally {
            setProcessing(false);
        }
    }

    return (
        <div className='current-membership-card'>
            <span className='current-membership-card-subtext'>Your Current Plan</span>
            <div className="d-flex align-items-center justify-content-between gap-2">
                <div className="d-flex flex-column gap-3">
                    <div className="d-flex align-items-center gap-3">
                        <h3 className='active-plan-name m-0'>{(activePlan?.plan?.name ?? '').toUpperCase()} PLAN</h3>
                        <span className="active-plan-badge">Active</span>
                        <span className='auto-renewal-badge'>{activePlan?.auto_renew ? <>Next Renewal Date: <b>{activePlan?.next_due_date}</b></> : <>Plan Ending On: <b>{activePlan?.next_due_date}</b></>}</span>
                    </div>
                    <div className="active-plan-features">
                        {
                            subscriptionFeatures.commission_rule_percent?.is_visible &&
                            <div className="d-flex align-items-center gap-1">
                                <span className="active-plan-feature-label">{subscriptionFeatures.commission_rule_percent?.display_title}:</span>
                                <span className="active-plan-feature-value">{subscriptionFeatures.commission_rule_percent?.applicable_limit}%</span>
                            </div>
                        }
                        {
                            subscriptionFeatures.collabs?.is_visible &&
                            <div className="d-flex align-items-center gap-1">
                                <span className="active-plan-feature-label">{subscriptionFeatures.collabs?.display_title} {subscriptionFeatures?.collabs?.unit_title}{subscriptionFeatures?.collabs?.applicable_limit > 1 ? 's' : ''}</span>
                                <span className="active-plan-feature-value">{subscriptionFeatures.collabs?.consumed_limit}/{subscriptionFeatures.collabs?.applicable_limit}</span>
                            </div>
                        }
                        {
                            subscriptionFeatures.max_competitors?.is_visible &&
                            <div className="d-flex align-items-center gap-1">
                                <span className="active-plan-feature-label">{subscriptionFeatures.max_competitors?.display_title} {subscriptionFeatures?.max_competitors?.unit_title}{subscriptionFeatures?.max_competitors?.applicable_limit > 1 ? 's' : ''}</span>
                                <span className="active-plan-feature-value">{subscriptionFeatures.max_competitors?.consumed_limit}/{subscriptionFeatures.max_competitors?.applicable_limit}</span>
                            </div>
                        }
                        {
                            subscriptionFeatures.max_ig_accounts?.is_visible &&
                            <div className="d-flex align-items-center gap-1">
                                <span className="active-plan-feature-label">{subscriptionFeatures.max_ig_accounts?.display_title} {subscriptionFeatures?.max_ig_accounts?.unit_title}{subscriptionFeatures?.max_ig_accounts?.applicable_limit > 1 ? 's' : ''}</span>
                                <span className="active-plan-feature-value">{subscriptionFeatures.max_ig_accounts?.consumed_limit}/{subscriptionFeatures.max_ig_accounts?.applicable_limit}</span>
                            </div>
                        }
                    </div>
                </div>
                {
                    activePlan?.auto_renew &&
                    <button className='btn btn-gradient' onClick={handleCancelMembership} disabled={processing}>{processing ? 'CANCELLING...' : 'CANCEL PLAN'}</button>
                }
            </div>
            <PlanDurationBanner onAction={(planId) => onProceedToCheckout?.(planId, 'monthly')} />
        </div>
    )
}

export default CurrentMembershipCard